const __WEBPACK_NAMESPACE_OBJECT__ = require("@babylonjs/core/Meshes/mesh.vertexData");